module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNTFmZWIzOWE3MzY0OGMwOTJjOWQ3ODFhODY5MDgyM2UucG5nIjs="